<button type="button" class="apps-button">
  <span em-icon="apps"></span>
</button>
<div uk-dropdown="mode: click; pos: bottom-right; offset: 2px">
  <ul class="uk-nav uk-dropdown-nav">
    @for (app of apps(); track app.link) {
      <li>
        <a class="uk-drop-close" uiSref="deepLink" [uiParams]="{ app: app.id}">{{ app.text }}</a>
      </li>
    }
  </ul>
</div>
